import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-skeleton',
  standalone: true,
  templateUrl: './my-onboarding-skeleton.component.html',
})
export class MyOnboardingSkeletonComponent {}
